import React from 'react';
import Grid from "@mui/material/Grid";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {Typography} from "@material-ui/core";

export default function Completed() {
    return (
                <Grid container direction={"row"} spacing={2} padding={2} data-testid={"completed"}>
                    <Grid item xs={12}>
                        <Typography component="h1" variant="h4" align="center" style={{margin:'1%'}}>
                            Thank you
                        </Typography>
                    </Grid>

                    <Grid item xs={12} >
                        <Typography align="center" style={{margin:'1%'}}>
                            <CheckCircleOutlineIcon align={"center"} sx={{ color: "#FF6600", fontSize: 150}}/>
                        </Typography>

                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" align="center" style={{fontWeight: 500, margin:'1%'}}>
                            We have received your application and will be in
                            contact with you around the next stages.
                        </Typography>
                    </Grid>
                </Grid>
    )
}